"use strict";
import { renderTemplate } from "./templates";
const LoadEmailCreator = function(loadState, carrierInvoice, user, subjectTemplateOverride, bodyTemplateOverride, templateVariables, carrier) {
  const defaultSubjectTemplate = "{account_name} Questions{#if {invoice_number}} for Invoice {invoice_number}{#endif} on Load {load_id}: {exception_summary}";
  const defaultBodyTemplate = "Hi\n\nWe're seeing a few issues with load {load_id}:\n\n{exception_messages}\n\n{signature}\n";
  const bodyTemplateVariables = [
    "{account_name}",
    "{carrier_name}",
    "{invoice_number}",
    "{load_id}",
    "{order_id}",
    "{order_ids}",
    "{exception_messages}",
    "{signature}"
  ];
  const buildSubject = () => {
    if (_.str.isBlank(subjectTemplateOverride)) {
      subjectTemplateOverride = defaultSubjectTemplate;
    }
    return renderTemplate(subjectTemplateOverride, templateVariables, user, loadState, [carrierInvoice], carrier);
  };
  return {
    initialEmail: function() {
      return {
        subject: buildSubject(),
        body: this.buildBody()
      };
    },
    buildBody: function() {
      if (_.str.isBlank(bodyTemplateOverride)) {
        bodyTemplateOverride = defaultBodyTemplate;
      }
      return renderTemplate(bodyTemplateOverride, bodyTemplateVariables, user, loadState, [carrierInvoice], carrier);
    }
  };
};
export default LoadEmailCreator;
